import { AutoComplete } from 'antd';
import React, { FC, CSSProperties } from 'react';
import { hintChildren } from '@/presentation/components/hint-text/hintText';
import styles from '@/presentation/components/tapd/index.module.scss';
import { FilterOptions } from '@/proto/alert';

interface IProps {
  name: string | null | undefined,
  label: string | null | undefined,
  options: FilterOptions[],
  getNewFields: (changeValue: string | number, name?: string | null) => void,
  value?: string | number | null | undefined,
  handleSelectChange?: (val: string | number, key?: string) => void,
  labelWidth?: string,
  renderSelectWidth?: string,
  style?: CSSProperties,
}

export const RenderAutoComplete: FC <IProps> = (props) => {
  const {
    name,
    label,
    options,
    getNewFields,
    value,
    labelWidth,
    renderSelectWidth,
    style,
  } = props;

  return <div style={{
    display: 'flex',
    marginBottom: '20px',
    width: renderSelectWidth ?? '350px',
  }}>
    <span className={styles.overflow} style={labelWidth ? { width: labelWidth } : undefined}>
      {hintChildren(label, label)}
    </span>
    <AutoComplete
      showSearch
      options={options}
      defaultValue={value}
      value={value}
      dropdownMatchSelectWidth={250}
      filterOption={(value, options) => {
        if (value && options) {
          return options.label.toLowerCase().includes(value.toLowerCase());
        }
        return false;
      }}
      onChange={(changeValue: string | number) => {
        getNewFields(changeValue, name);
      }}
      style={style ?? { width: '200px' }}
    >
    </AutoComplete>
  </div>;
};
